export const itemDescription = {
  B: 'Source Controlled Item',
  D: 'Specification/Standard/Drawing Item',
  N: 'Non-NSN Item',
  P: 'Approved Source Item',
  Q: 'Qualified Products List (QPL) Item',
  S: 'Service Material Item',
};

export const pnOfferedCode = {
  1: 'Exact Product',
  2: 'Alternate Product',
  3: 'Superseding P/N - Administrative Change Only',
  4: 'Superseding P/N - Minor Change / No Change In Configuration',
  5: 'Previously-Approved Product',
  6: 'CAGE/PN Correction - CAGE Code In Error/Same Corp., Different Division',
  7: 'CAGE/PN Correction - CAGE Code In Error/Sold To Different Corp.',
  8: 'CAGE/PN Correction - Part Number Not Recognized',
  9: 'CAGE & P/N Correction - Obsolete Part Number',
  A:
    "CAGE & P/N Correction - Other Valid Codes Where Item Description Indicator  equals 'Source Controlled Item'",
};

export const higherLevel = {
  N: 'Not Applicable',
  7: 'ISO 9001:2015',
  6: 'SAE AS9003 or ISO 9001 tailored to meet SAE AS9003',
};

export const higherSeven = {
  7: 'ISO 9001:2015',
  2: 'Other Equivalent',
  1: 'None',
};

export const higherAll = {
  N: 'Not Applicable',
  7: 'ISO 9001:2015',
  6: 'SAE AS9003 or ISO 9001 tailored to meet SAE AS9003',
  2: 'Other Equivalent',
  1: 'None',
};

export const higherSix = {
  7: 'ISO 9001:2015',
  6: 'SAE AS9003 or ISO 9001 tailored to meet SAE AS9003',
  2: 'Other Equivalent',
  1: 'None',
};

export const tradeIndicator = {
  N: 'Not Applicable',
  Y: 'Trade Agreements',
  I: 'Information Only (overseas Shipment)',
};

export const manufacturer = {
  DD: 'Dealer',
  MM: 'Manufacturer',
  QD: 'Qualified Supplier List Dealer',
  QM: 'Qualified Supplier List Manufacturer',
};

export const hazmat = {
  1: 'Hazardous Communication Standard',
  2: 'Federal Insecticide, Fungicide and Rodenicide Act',
  3: 'Federal Food, Drug, and Cosmetic Act',
  4: 'Consumer Product Safety Act',
  5: 'Federal Hazardous Substance Act',
  6: 'Federal Alcohol Administration Act',
  7: 'Not Applicable',
};

export const matType = {
  0: 'New',
  1: 'Other than New (Used)',
  2: 'Reconditioned',
  3: 'Remanufactured',
  4: 'New/Unused Government Surplus',
};

export const buyAmerican = {
  N: 'Not Applicable',
  Y: 'Applicable',
  I: 'Informational Only (Overseas Shipment)',
};

export const freeTrade = {
  N: 'Not Applicable',
  Y: 'Free Trade Agreements',
  A: 'Free Trade Agreements ALT I',
  B: 'Free Trade Agreements ALT IV',
  I: 'Informational Only (Overseas Shipment)',
};



// WEBPACK FOOTER //
// ./src/components/DibbsTabs/options.js